document.addEventListener("DOMContentLoaded", () => {
  /*
    JS to handle Compatible Filters option selection
  */
  const filters = document.querySelectorAll(".compatible-filter");
  let currentOpenFilter = null;
  let selectedRadio = null;

  // mirror each hidden radio's state onto its wrapper (role="button")
  // so screen readers announce selected / not selected
  function syncFilterAria() {
    filters.forEach((f) => {
      const wrapper = f.querySelector(".compatible-filter__image-wrapper");
      const r = f.querySelector(".filter-radio");
      if (wrapper && r) {
        wrapper.setAttribute("aria-pressed", r.checked ? "true" : "false");
      }
    });
  }

  // hide an open details popover (selection stays, same as the close button)
  function hideFilterDetails(filter) {
    const details = filter.querySelector(".compatible-filter__details");
    const arrowIcon = filter.querySelector(".compatible-filter__arrow");
    if (details) details.classList.add("hidden");
    if (arrowIcon) arrowIcon.classList.add("hidden");
    syncFilterAria();
  }

  filters.forEach((filter) => {
    const imageWrapper = filter.querySelector(
      ".compatible-filter__image-wrapper"
    );
    const details = filter.querySelector(".compatible-filter__details");
    const closeBtn = filter.querySelector(".compatible-filter__close");
    const arrowIcon = filter.querySelector(".compatible-filter__arrow");
    const radio = filter.querySelector(".filter-radio");

    imageWrapper.addEventListener("click", () => {
      const isSelectable = filter.getAttribute("data-selectable") === "true";

      if (!isSelectable) return;

      // removing previous filter design when clicked on any other filter
      if (currentOpenFilter && currentOpenFilter !== filter) {
        const currentDetails = currentOpenFilter.querySelector(
          ".compatible-filter__details"
        );
        const currentWrapper = currentOpenFilter.querySelector(
          ".compatible-filter__image-wrapper"
        );
        const currentArrow = currentOpenFilter.querySelector(
          ".compatible-filter__arrow"
        );
        const currentRadio = currentOpenFilter.querySelector(".filter-radio");

        currentDetails.classList.add("hidden");
        currentArrow.classList.add("hidden");
        currentWrapper.classList.remove("active");

        // unchecking the previous radio button
        if (currentRadio) {
          currentRadio.checked = false;
        }
      }

      const detailsHidden = details.classList.contains("hidden");
      const isActive = imageWrapper.classList.contains("active");

      /* if details are hidden but active class exists - it means close button was used -
      in such case removing the active class */
      if (detailsHidden && isActive) {
        imageWrapper.classList.remove("active");
        currentOpenFilter = null;
        radio.checked = false;
        selectedRadio = null;
      } else {
        imageWrapper.classList.toggle("active");
        details.classList.toggle("hidden");
        arrowIcon.classList.toggle("hidden");

        const isNowOpen = !details.classList.contains("hidden");
        if (isNowOpen) {
          radio.checked = true;
          selectedRadio = radio;
          currentOpenFilter = filter;
        } else {
          radio.checked = false;
          selectedRadio = null;
          currentOpenFilter = null;
        }
      }

      syncFilterAria();
    });

    // keyboard: Enter / Space activates the wrapper like a click
    imageWrapper.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        imageWrapper.click();
      }
    });

    closeBtn.addEventListener("click", () => {
      hideFilterDetails(filter);
    });
  });

  // dismiss an open details popover on outside click / Escape
  if (filters.length) {
    document.addEventListener("click", (e) => {
      if (!currentOpenFilter) return;
      if (e.target.closest(".compatible-filter")) return;
      hideFilterDetails(currentOpenFilter);
    });

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape" || !currentOpenFilter) return;
      const openDetails = currentOpenFilter.querySelector(
        ".compatible-filter__details"
      );
      if (openDetails && !openDetails.classList.contains("hidden")) {
        hideFilterDetails(currentOpenFilter);
        const wrapper = currentOpenFilter.querySelector(
          ".compatible-filter__image-wrapper"
        );
        if (wrapper) wrapper.focus();
      }
    });
  }

  /*
    JS to handle Add to cart functionality for Compatible Filters
  */
  const filterSubmitButton = document.getElementById("addToCartBtn");
  const nativeSubmitButton = document.querySelector(
    '[data-ref="submitButton"]'
  );

  /*
    Variant state sync — resolves the selected variant from the option
    buttons and updates price / compare-at price / availability chip /
    Add to Cart state. Prices come pre-formatted from Liquid in the
    [data-pdp-variant-data] JSON blob.
    (runs even without an Add to Cart button so option selection
    still highlights on enquiry-only products)
  */
  /* scope to the PDP details column so product cards elsewhere on the
     page (with their own option pickers) are never picked up */
  const pdpRoot = document.querySelector("[data-ap-pdp]") || document;

  const optionButtons = pdpRoot.querySelectorAll(
    ".product-button-option__button-item"
  );

  const productFormEl = pdpRoot.querySelector("product-form[product]");
  let productData = null;
  if (productFormEl) {
    try {
      productData = JSON.parse(productFormEl.getAttribute("product"));
    } catch (err) {
      productData = null;
    }
  }

  let variantData = null;
  const variantDataEl = pdpRoot.querySelector("[data-pdp-variant-data]");
  if (variantDataEl) {
    try {
      variantData = JSON.parse(variantDataEl.textContent);
    } catch (err) {
      variantData = null;
    }
  }

  const priceBlockEl = pdpRoot.querySelector("[data-pdp-price-block]");
  const priceFinalEl = pdpRoot.querySelector("[data-pdp-price-final]");
  const priceCompareEl = pdpRoot.querySelector("[data-pdp-price-compare]");
  const chipEl = pdpRoot.querySelector("[data-pdp-chip]");

  function getSelectedVariant() {
    if (!productData || !productData.variants) return null;
    const groups = pdpRoot.querySelectorAll(
      "product-option-picker product-button-option"
    );
    const opts = [];
    groups.forEach((group) => {
      const active = group.querySelector(
        ".product-button-option__button-item--active input[type='radio']"
      );
      opts.push(active ? active.value : null);
    });
    if (!opts.length) return null;
    return (
      productData.variants.find((v) =>
        v.options.every((value, i) => opts[i] === null || opts[i] === value)
      ) || null
    );
  }

  pdpRoot.apGetSelectedVariant = getSelectedVariant;

  function updateVariantState() {
    const variant = getSelectedVariant();
    const data =
      variant && variantData ? variantData[String(variant.id)] : null;

    /* price + compare-at */
    if (data && priceFinalEl) {
      priceFinalEl.textContent = data.price;
    }
    if (data && priceCompareEl) {
      if (data.compare) {
        priceCompareEl.textContent = data.compare;
        priceCompareEl.hidden = false;
      } else {
        priceCompareEl.textContent = "";
        priceCompareEl.hidden = true;
      }
    }

    /* availability — prefer live variant data, fall back to the
       Liquid-rendered out-of-stock class on the active option */
    let isOutOfStock = false;
    if (data) {
      isOutOfStock = !data.available;
    } else {
      const selectedButton = pdpRoot.querySelector(
        ".product-button-option__button-item--active"
      );
      if (!selectedButton) return;
      isOutOfStock = selectedButton.classList.contains(
        "product-button-option__button-item--out-of-stock"
      );
    }

    /* price hidden for out-of-stock variants (buy mode only shows it) */
    if (priceBlockEl) {
      priceBlockEl.hidden = isOutOfStock;
    }

    /* chip: BUY ONLINE AVAILABLE <-> SALES INQUIRY AVAILABLE */
    if (chipEl) {
      chipEl.classList.toggle("chip-green", !isOutOfStock);
      chipEl.classList.toggle("chip-cyan", isOutOfStock);
      chipEl.textContent = isOutOfStock
        ? chipEl.getAttribute("data-t-enquiry")
        : chipEl.getAttribute("data-t-available");
    }

    if (filterSubmitButton) {
      filterSubmitButton.disabled = isOutOfStock;
      filterSubmitButton.classList.toggle(
        "product-form__submit--disabled",
        isOutOfStock
      );
    }
  }

  optionButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      // removing active class from all buttons in the same group and adding it to the clicked button
      const group = btn.closest("product-button-option");
      const groupButtons = group
        ? group.querySelectorAll(".product-button-option__button-item")
        : optionButtons;
      groupButtons.forEach((b) =>
        b.classList.remove("product-button-option__button-item--active")
      );
      btn.classList.add("product-button-option__button-item--active");

      updateVariantState();
    });
  });

  updateVariantState();

  if (!filterSubmitButton || !nativeSubmitButton) return;

  filterSubmitButton.addEventListener("click", async (e) => {
    e.preventDefault();
    filterSubmitButton.disabled = true;

    const selectedFilter = document.querySelector(".filter-radio:checked");

    if (selectedFilter) {
      const filterId = selectedFilter.value;
      try {
        await fetch("/cart/add", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: filterId,
            quantity: 1,
          }),
        });
      } catch (err) {
        console.error("Failed to add filter: ", err);
      }
    }
    // Re-enable BEFORE click(): cart-quantity-guard snapshots the button's disabled state inside it; 
    // re-enabling after would poison the snapshot and override the guard's lock.
    filterSubmitButton.disabled = false;
    nativeSubmitButton.click();
  });
});

/*
  Colour swatch tooltip. CSS :hover handles pointer devices; on touch a tap
  shows the name for a moment, or until the next tap anywhere.
*/
document.addEventListener("DOMContentLoaded", () => {
  const touchOnly = window.matchMedia("(hover: none)");
  const OPEN_CLASS = "product-button-option__button-item--tip-open";
  const HIDE_AFTER_MS = 2500;
  let hideTimer = null;

  function closeAll() {
    clearTimeout(hideTimer);
    document.querySelectorAll(`.${OPEN_CLASS}`).forEach((item) => {
      item.classList.remove(OPEN_CLASS);
      const tip = item.querySelector(".product-button-option__swatch-tooltip");
      if (tip) tip.style.removeProperty("--tip-shift");
    });
  }

  // keep the tooltip on screen when the swatch sits near an edge
  function clampToViewport(tip) {
    const margin = 8;
    const rect = tip.getBoundingClientRect();
    let shift = 0;
    if (rect.left < margin) {
      shift = margin - rect.left;
    } else if (rect.right > window.innerWidth - margin) {
      shift = window.innerWidth - margin - rect.right;
    }
    if (shift) tip.style.setProperty("--tip-shift", `${shift}px`);
  }

  // pointer devices: CSS shows the tooltip, we only clamp it
  const LABEL = ".product-button-option__button-item-label--swatch";
  document.addEventListener("mouseover", (event) => {
    const label = event.target.closest(LABEL);
    if (!label || touchOnly.matches) return;
    if (label.contains(event.relatedTarget)) return;
    const tip = label.querySelector(".product-button-option__swatch-tooltip");
    if (tip) clampToViewport(tip);
  });
  document.addEventListener("mouseout", (event) => {
    // taps fire mouse events too; the tap handler owns the shift then
    if (touchOnly.matches) return;
    const label = event.target.closest(LABEL);
    if (!label || label.contains(event.relatedTarget)) return;
    const tip = label.querySelector(".product-button-option__swatch-tooltip");
    if (tip) tip.style.removeProperty("--tip-shift");
  });

  document.addEventListener("click", (event) => {
    // match the whole item: a label tap also fires a click on its radio input,
    // and that second click must not count as "tapped elsewhere"
    const item = event.target.closest(
      ".product-button-option__button-item--swatch"
    );
    const tip = item?.querySelector(".product-button-option__swatch-tooltip");
    if (!item || !tip || !touchOnly.matches) {
      closeAll();
      return;
    }
    if (item.classList.contains(OPEN_CLASS)) return;

    closeAll();
    item.classList.add(OPEN_CLASS);
    clampToViewport(tip);
    hideTimer = setTimeout(closeAll, HIDE_AFTER_MS);
  });
});
